import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

export interface CreateAnnouncementInput {
  contentHtml: string;
  narrativeId: string;
}

const QUERY = gql(`
  mutation createNarrativeAnnouncement($input: CreateAnnouncementInput!) {
    createNarrativeAnnouncement(input: $input) {
      id
      createdAt
      contentHtml
    }
  }
`);

type Args = VariablesOf<typeof QUERY>['input'];

export const mutationFn = async ({ contentHtml, narrativeId }: Args) => {
  const response = await gqlClient.request(QUERY, {
    input: {
      contentHtml,
      narrativeId,
    },
  });

  if ('createNarrativeAnnouncement' in response) {
    return response.createNarrativeAnnouncement;
  }
};
